export default __webpack_public_path__ + "static/media/goat_404.ac599566.svg";